import { render, staticRenderFns } from "./CharacterAttributeTypesInput.vue?vue&type=template&id=0ee89ce2&lang=pug&"
import script from "./CharacterAttributeTypesInput.vue?vue&type=script&lang=js&"
export * from "./CharacterAttributeTypesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterAttributeTypesInput.vue"
export default component.exports